import isEqual from 'lodash/isEqual';
import type { Action } from 'react-sweet-state';
import type { State } from '../../types';
import type { SetFieldCacheProps } from './types';

export type { SetFieldCacheProps } from './types';

export const setFieldCache =
	({ fieldKey, projectKey, prefetched, recentlySelected }: SetFieldCacheProps): Action<State> =>
	({ setState, getState }) => {
		const fieldVal = getState()[fieldKey];
		const projectVal = fieldVal[projectKey];

		const newFieldVal = {
			...fieldVal,
			[projectKey]: {
				...projectVal,
				...(prefetched ? { prefetched } : {}),
				...(recentlySelected ? { recentlySelected } : {}),
			},
		};

		if (isEqual(fieldVal, newFieldVal)) {
			return;
		}

		setState({ [fieldKey]: newFieldVal });
	};
